import BulkCouponUpload from "../../../views/BulkCouponUpload";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkCouponCodeUploadRoutes = [
  {
    menuName: MenuNames.SPIN_THE_WHEEL,
    path: "/bulk-coupon-upload",
    component: BulkCouponUpload,
    exact: true,
  },
];

export default BulkCouponCodeUploadRoutes;
